import { MouseEvent, MouseEventHandler } from "react";
import { PRODUCT_STATE_CODE_OBJ } from "./const";
import { productListFilterCodeType, productStateCodeType } from "../interface/ProductList.interface";
import { NavigateFunction } from "react-router-dom";
import { backPointUrlManagerClass, localStorageManagerClass } from "../../../../Common/ts/appTools";
import { addressDataInterface } from "../../../../Component/Elements/Postcode/interface/useDaumPostcode.interface";
import { albumDataInterface, recipientInfoInterface } from "../interface/common.interface";
import { callAxios, customToast, dev_console, getQueryParamsUrl, printStateMsg } from "../../../../Common/ts/commonTools";
import { ProductDetail_SelectInformationDate_Address_Interface } from "../interface/ProductDetail.interface";
import { RTN_interface } from "../../../../Common/interface/App.interface";
import { defaultApiReaponseInterface } from "../../../../Common/interface/Common.interface";

const backPointUrlManager = new backPointUrlManagerClass();

// 제품목록에서 제품을 클릭했을때 페이지를 이동하는 핸들러 함수를 생성하는 함수
export function getGotoPageClickEvent(
    {
        status_cd,
        contract_product_id,
        album_save_id,
        photo_upload_id,
        navigate,
        tab1,
    }:{
        status_cd: productStateCodeType;
        contract_product_id: number;
        album_save_id: number | null;
        photo_upload_id: number | null;
        navigate: NavigateFunction
        tab1: productListFilterCodeType;
    }
){
    let RTN: MouseEventHandler<HTMLDivElement | HTMLButtonElement> = () => {}

    const l_back_point: string = backPointUrlManager.encoded({url: `/productList?tab1=${tab1}`});

    const l_productDetail_url = getQueryParamsUrl({
        main_url: "/productDetail",
        queryParams: {
            contract_product_id: `${contract_product_id || ""}`,
            album_save_id: `${album_save_id || ""}`,
            photo_upload_id: `${photo_upload_id || ""}`,
            back_point: l_back_point,
        }
    })

    const l_productRequestEdit_url = getQueryParamsUrl({
        main_url: "/productRequestEdit",
        queryParams: {
            contract_product_id: `${contract_product_id || ""}`,
            album_save_id: album_save_id !== null ? `${album_save_id}` : "",
            photo_upload_id: photo_upload_id !== null ? `${photo_upload_id}` : "",
            back_point: l_back_point,
        }
    })

    switch(status_cd){
        case PRODUCT_STATE_CODE_OBJ.application_not_possible:
            break;
        case PRODUCT_STATE_CODE_OBJ.application_possible:
            RTN = () => {
                navigate(l_productRequestEdit_url)
            }
            break;
        case PRODUCT_STATE_CODE_OBJ.application_in_progress:
            RTN = () => {
                navigate(l_productDetail_url)
            }
            break;
        case PRODUCT_STATE_CODE_OBJ.editing:
            RTN = () => {
                navigate(l_productDetail_url)
            }
            break;
        case PRODUCT_STATE_CODE_OBJ.confirm_request:
            RTN = () => {
                navigate(l_productDetail_url)
            }
            break;
        case PRODUCT_STATE_CODE_OBJ.edit_end:
            RTN = () => {
                navigate(l_productDetail_url)
            }
            break;
        case PRODUCT_STATE_CODE_OBJ.confirm_rejected:
            RTN = () => {
                navigate(l_productDetail_url)
            }
            break;
    }

    return RTN;
}

// 저장소에 제품제작신청관련 입력한 정보 저장 및 불러오기를 관리하는 클래스
// 서버에서 주소를 관리하기 시작하면 사용할 일이 없을것이다.
export class userDataStorageManagerClass{
    localStorageManager: localStorageManagerClass;

    // babyInfo와 address를 속성으로 추가
    babyInfo: {
        get: () => albumDataInterface | null;
        set: (data: albumDataInterface) => any;
        remove: () => boolean;
    };

    address: {
        get: () => addressDataInterface | null;
        set: (data: addressDataInterface) => any;
        remove: () => boolean;
    };

    recipientInfo: {
        get: () => recipientInfoInterface | null;
        set: (data: recipientInfoInterface) => any;
        remove: () => boolean;
    };

    constructor() {
        this.localStorageManager = new localStorageManagerClass(this);

        // babyInfo 객체 정의
        this.babyInfo = {
            get: () => {
                const RTN = this.localStorageManager.get<albumDataInterface>("babyInfo");

                // JSON.parse로 복구하더라도 Date객체는 문자열인상태로 남아있게된다. 따라서 이를 복구하는 로직이 별도로 필요하다.
                if(RTN && RTN.baby_birth){
                    let baby_birth: Date = new Date(RTN.baby_birth);

                    if(isNaN(baby_birth.getTime())){
                        RTN.baby_birth = null;
                    }else{
                        RTN.baby_birth = baby_birth;
                    }
                }

                if(RTN && RTN.baby_birth_time){
                    let m_baby_birth_time: Date = new Date(RTN.baby_birth_time);

                    if(isNaN(m_baby_birth_time.getTime())){
                        RTN.baby_birth_time = null;
                    }else{
                        RTN.baby_birth_time = m_baby_birth_time;
                    }
                }

                return RTN;
            },
            set: (data: albumDataInterface) => {
                return this.localStorageManager.set<albumDataInterface>({
                    key: "babyInfo",
                    data,
                });
            },
            remove: () => {
                return this.localStorageManager.remove("babyInfo");
            },
        };

        // address 객체 정의
        this.address = {
            get: () => {
                return this.localStorageManager.get<addressDataInterface>("address");
            },
            set: (data: addressDataInterface) => {
                return this.localStorageManager.set<addressDataInterface>({
                    key: "address",
                    data,
                });
            },
            remove: () => {
                return this.localStorageManager.remove("address");
            },
        };

        // 받는이 정보
        this.recipientInfo = {
            get: () => {
                return this.localStorageManager.get<recipientInfoInterface>("recipientInfo");
            },
            set: (data: recipientInfoInterface) => {
                return this.localStorageManager.set<recipientInfoInterface>({
                    key: "recipientInfo",
                    data: {
                        recipient_name: data.recipient_name,
                        recipient_phone: data.recipient_phone.replaceAll("-", ""),
                    },
                });
            },
            remove: () => {
                return this.localStorageManager.remove("recipientInfo");
            },
        }
    }
};

// 제품 제작 신청 페이지에서 주소를 관리하는 클래스
export class addressListManagerClass{
    addNewAddress(
        {
            address_list,
            data,
            addressListSetter,
        }:{
            address_list: ProductDetail_SelectInformationDate_Address_Interface[];
            data: ProductDetail_SelectInformationDate_Address_Interface;
            addressListSetter: (addressList: ProductDetail_SelectInformationDate_Address_Interface[]) => void;
        }
    ){
        const RTN: RTN_interface<ProductDetail_SelectInformationDate_Address_Interface[]> = {
            sign: false,
            msg: "",
            data: [...address_list],
        }

        RTN.data.push(data);
        RTN.sign = true;
        RTN.msg = "배송지 정보가 추가되었습니다.";

        if(RTN.sign){
            addressListSetter(RTN.data);
        }

        return RTN;
    }

    editAddress(
        {
            address_list,
            data,
            index,
            addressListSetter,
        }:{
            address_list: ProductDetail_SelectInformationDate_Address_Interface[];
            data: ProductDetail_SelectInformationDate_Address_Interface;
            index: number;
            addressListSetter: (addressList: ProductDetail_SelectInformationDate_Address_Interface[]) => void;
        }
    ){
        const RTN: RTN_interface<ProductDetail_SelectInformationDate_Address_Interface[]> = {
            sign: false,
            msg: "",
            data: [...address_list],
        }

        Action:{
            if(index < 0){
                RTN.msg = "index가 0보다 작습니다.";
                break Action;
            }

            if(index >= address_list.length){
                RTN.msg = "index가 배열의 길이보다 큽니다.";
                break Action;
            }

            RTN.data[index] = data;
            RTN.sign = true;
            RTN.msg = "배송지 정보가 수정되었습니다.";

            break Action;
        }

        if(RTN.sign){
            addressListSetter(RTN.data);
        }else{
            dev_console.error(RTN.msg);
        }

        return RTN;
    }

    removeAddress(
        {
            address_list,
            index,
            addressListSetter,
        }:{
            address_list: ProductDetail_SelectInformationDate_Address_Interface[];
            index: number;
            addressListSetter: (addressList: ProductDetail_SelectInformationDate_Address_Interface[]) => void;
        }
    ){
        const RTN: RTN_interface<ProductDetail_SelectInformationDate_Address_Interface[]> = {
            sign: false,
            msg: "",
            data: [...address_list],
        }

        Action:{
            if(!window.confirm("배송지 정보를 삭제하시겠습니까?")){
                RTN.msg = "배송지 정보 삭제가 취소되었습니다.";
                break Action;
            }

            if(index < 0){
                RTN.msg = "index가 0보다 작습니다.";
                break Action;
            }

            if(index >= address_list.length){
                RTN.msg = "index가 배열의 길이보다 큽니다.";
                break Action;
            }

            RTN.data.splice(index, 1);
            RTN.sign = true;
            RTN.msg = "배송지 정보가 삭제되었습니다.";
        }

        if(RTN.sign){
            addressListSetter(RTN.data);
        }else{
            dev_console.error(RTN.msg);
        }

        return RTN;
    }

    addQty(
        {
            address_list,
            index,
            addressListSetter,
        }:{
            address_list: ProductDetail_SelectInformationDate_Address_Interface[];
            index: number;
            addressListSetter: (addressList: ProductDetail_SelectInformationDate_Address_Interface[]) => void;
        }
    ){
        const RTN: RTN_interface<ProductDetail_SelectInformationDate_Address_Interface[]> = {
            sign: false,
            msg: "",
            data: [...address_list],
        }

        RTN.data[index].product_qty += 1;
        RTN.sign = true;
        RTN.msg = "배송지 수량이 증가되었습니다.";

        if(RTN.sign){
            addressListSetter(RTN.data);
        }else{
            dev_console.error(RTN.msg);
        }

        return RTN;
    }

    subQty(
        {
            address_list,
            index,
            addressListSetter,
        }:{
            address_list: ProductDetail_SelectInformationDate_Address_Interface[];
            index: number;
            addressListSetter: (addressList: ProductDetail_SelectInformationDate_Address_Interface[]) => void;
        }
    ){
        const RTN: RTN_interface<ProductDetail_SelectInformationDate_Address_Interface[]> = {
            sign: false,
            msg: "",
            data: [...address_list],
        }

        RTN.data[index].product_qty -= 1;
        RTN.sign = true;
        RTN.msg = "배송지 수량이 감소되었습니다.";

        if(RTN.sign){
            addressListSetter(RTN.data);
        }else{
            dev_console.error(RTN.msg);
        }

        return RTN;
    }

    requestSetAddress(
        {
            album_save_id,
            addr_list,
            successHandler,
            errorHandler,
            defaultActionHandler,
        }:{
            album_save_id: number | null | undefined;
            addr_list: ProductDetail_SelectInformationDate_Address_Interface[];
            successHandler?: () => void;
            errorHandler?: () => void;
            defaultActionHandler?: () => void;
        }
    ){
        const TOAST_ID = "requestSetAddress";

        if(!window.confirm("주소를 변경하시겠습니까?")){
            return ;
        }

        // 전송하기 직전에, 전화번호에 붙어있는 - 을 제거해준다.
        const m_addr_list_clear_hypen = addr_list.map((item) => {
            const m_item = {...item};
            m_item.recipient_phone = m_item.recipient_phone.replaceAll("-", "");
            return m_item;
        });

        const config = {
            album_save_id,
            addr_list: m_addr_list_clear_hypen
        }

        const photo_select_add_update_url = "api/v3/customers/photo-select-add-update2";

        callAxios.api({
            url: photo_select_add_update_url,
            method: "post",
            data: config,
        })
        .then(async (response) => {
            dev_console.log(photo_select_add_update_url);
            dev_console.log(response);

            const RTN: RTN_interface<null> = {
                sign: false,
                msg: "",
                data: null,
            }

            ResponseAction:{
                const data: defaultApiReaponseInterface<null> = response.data;

                if(data.status.code === 200){
                    RTN.sign = true;
                    RTN.msg = "주소 변경이 완료되었습니다.";
                    break ResponseAction;
                }

                if(data.status.code === 201){
                    RTN.sign = false;
                    RTN.msg = "제품 제작이 시작되어 주소 변경이 불가능합니다.";
                    break ResponseAction;
                }

                RTN.sign = false;
                RTN.msg = "주소 변경에 실패했습니다.";
            }

            if(RTN.sign){
                customToast.success({
                    msg: RTN.msg,
                    toastId: TOAST_ID,
                });

                successHandler?.();
            }else{
                printStateMsg(response);
                customToast.error({
                    msg: RTN.msg,
                    toastId: TOAST_ID,
                });

                errorHandler?.();
            }
        })
        .catch((error) => {
            dev_console.error(error);
            customToast.error({
                msg: "주소 변경 요청 과정에서 문제가 발생했습니다.",
                toastId: TOAST_ID,
            });

            errorHandler?.();
        })
        .finally(() => {
            defaultActionHandler?.();
        })
    }
};